module.exports = __webpack_public_path__ + "img/cafe_pc_02.3880e189.png";